import { Popover } from 'antd';
import type { PopoverProps } from 'antd';

export interface DPopoverProps extends PopoverProps {}

export const DarwinPopover = (props: DPopoverProps) => {
  return <Popover {...props} />;
};
